import React from 'react';
import styled from 'styled-components';
/**
 * * 등록 & 수정 페이지 버튼 모음
 */

interface IProps {
  style?: React.CSSProperties;
  children: React.ReactElement;
}
const SubmitFlexBox = ({ style, children }: IProps) => {
  return <Container style={style}>{children}</Container>;
};

export default SubmitFlexBox;
const Container = styled.div`
  z-index: 50;
  margin-bottom: 1.2rem;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
